// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');

// @components
const AccountPrecautoryWarnings = require('components/contactCenter/accountPrecautionaryWarnings/accountPrecautionaryWarnings');

// @actions
const { requestPrecautionaryWarnings } = require('actions/contactCenter/accountPrecautionaryWarnings');

class AccountWarningsView extends React.Component {

    componentDidMount() {
        const { match: { params: { accountId } }, requestPrecautionaryWarnings } = this.props;
        requestPrecautionaryWarnings(accountId);
    }

    render() {
        const { match: { params: { accountId } }, immAccounts, accountPrecautionaryWarnings } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId]);
        return (
            <AccountPrecautoryWarnings
                immAccount={immAccount}
                immAccountPrecautionaryWarnings={accountPrecautionaryWarnings}
            />
        );
    }

}

AccountWarningsView.propTypes = {
    match: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    requestPrecautionaryWarnings: PropTypes.func.isRequired,
    accountPrecautionaryWarnings: PropTypes.object.isRequired
}

module.exports.constructor = AccountWarningsView;
module.exports.AccountWarningsView = connect(
    state => ({
        accountPrecautionaryWarnings: state.accountPrecautionaryWarnings,
        immAccounts: state.accounts
    }),
    {
        requestPrecautionaryWarnings: requestPrecautionaryWarnings
    }
)(AccountWarningsView);
